(function () {

  'use strict';

    eclipseApp.factory('lostStolenDeviceService', function() {

        var accountNumber = '' ;
        var selectedFido = '';
        var reactivateNumber = '';
        var deviceDetails = {};
        var contactEmail = '';

        function setSelectedFido(data) {
            selectedFido = data;
        }

        function getSelectedFido() {
            return selectedFido;
        }

        function setAccountNumber(data) {
            accountNumber = data;
        }

        function getAccountNumber() {
            return accountNumber;
        }

        function setReactivateNumber(data) {
            reactivateNumber = data;
        }

        function getReactivateNumber() {
            return reactivateNumber;
        }

        function setDeviceDetails(data) {
            deviceDetails = data;
        }

        function getDeviceDetails() {
            return deviceDetails;
        }

        function setContactEmail(data) {
            contactEmail = data;
        }

        function getContactEmail() {
            return contactEmail;
        }

        return {

            setSelectedFido: setSelectedFido,
            getSelectedFido: getSelectedFido,
            setAccountNumber: setAccountNumber,
            getAccountNumber: getAccountNumber,
            setReactivateNumber: setReactivateNumber,
            getReactivateNumber: getReactivateNumber,
            setDeviceDetails: setDeviceDetails,
            getDeviceDetails: getDeviceDetails,
            setContactEmail: setContactEmail,
            getContactEmail: getContactEmail

        }


    });

})();
